import React, { memo } from 'react';

const SvgNoLuggage = () => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5 20.5v-14a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14M7 21.5h10M9 3.726V1h6v2.626"
      stroke="#17181A"
    />
    <path
      clipRule="evenodd"
      d="M5.5 23a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
      stroke="#17181A"
    />
    <path d="m16.043 9.067-8.067 8.067m0-8.067 8.067 8.067" stroke="#000" />
  </svg>
);

const Memo = memo(SvgNoLuggage);
export default Memo;
